//mui
import {Theme} from '@mui/material';

export const MuiTypography = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			fontFamily: 'Lato',
			color: theme.palette.neutral900,

			'& .MuiLink-root': {
				textDecoration: 'none',
				color: theme.palette.primary500,
				padding: '0 4px',
			},
		}),
	},

	variants: [
		{
			props: {variant: 'h1'} as any,
			style: {
				fontSize: 96,
				fontStyle: 'normal',
				fontWeight: 300,
				lineHeight: '112px',
				letterSpacing: '-1.5px',
			},
		},
		{
			props: {variant: 'h2'} as any,
			style: {
				fontSize: 60,
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: '72px',
				letterSpacing: '-0.5px',
			},
		},
		{
			props: {variant: 'h3'} as any,
			style: {
				fontSize: 48,
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: '56px',
			},
		},
		{
			props: {variant: 'h4'} as any,
			style: {
				fontSize: 34,
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: '42px',
				letterSpacing: '0.25px',
			},
		},
		{
			props: {variant: 'h5'} as any,
			style: {
				fontSize: 24,
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: '32px',
			},
		},
		{
			props: {variant: 'h6'} as any,
			style: {
				fontSize: 20,
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: '32px',
				letterSpacing: '0.15px',
			},
		},
		{
			props: {variant: 'subtitle1'} as any,
			style: {
				fontSize: 16,
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: '28px',
				letterSpacing: '0.15px',
			},
		},
		{
			props: {variant: 'subtitle2'} as any,
			style: {
				fontSize: 14,
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: '20px',
				letterSpacing: '0.1px',
			},
		},
		{
			props: {variant: 'body1'} as any,
			style: {
				fontSize: 16,
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: '24px',
				letterSpacing: '0.15px',
			},
		},
		{
			props: {variant: 'body2'} as any,
			style: {
				fontSize: 14,
				fontStyle: 'normal',
				fontWeight: 700,
				lineHeight: '20px',
				letterSpacing: '0.15px',
			},
		},
		{
			props: {variant: 'caption'} as any,
			style: {
				fontSize: 12,
				fontStyle: 'normal',
				fontWeight: 400,
				lineHeight: '20px',
				letterSpacing: '0.4px',
			},
		},
	],
};
